exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hide {\n  display: none !important;\n}\ndiv[col-id='checked'] {\n  pointer-events: all !important;\n}\n.solicitud-stock .estilo-grilla,\n.solicitud-stock #gridComponent {\n  height: auto !important;\n  margin-bottom: 50px;\n}\n.solicitud-stock .ag-pinned-left-cols-container,\n.solicitud-stock .ag-header .ag-pinned-left-header,\n.solicitud-stock .ag-body-horizontal-scroll .ag-horizontal-left-spacer {\n  display: none;\n}\n", ""]);

// exports
